import { RiPieChart2Line, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

export const NoData = () => {
  const { t } = useTranslation();

  const label = t('global.analysis.noData');

  return <NoDataLayout label={label} />;
};

const NoDataLayout = ({ label }: { label: string }) => {
  return (
    <Stack
      data-testid='no-project-data'
      center
      spacing={4}
      className='h-[540px] min-h-[160px] items-center justify-center'
    >
      <span className='flex h-12 w-12 items-center justify-center rounded-full bg-neutral-black-8'>
        <RiPieChart2Line size={20} className='text-text-secondary' />
      </span>
      <span className='typography-h3 text-text-secondary'>{label}</span>
    </Stack>
  );
};
